import styled from 'styled-components';
import {Tabs} from "antd";

export const StyledTabs = styled(Tabs)`
  .ant-collapse-header{
    background-color: var(--c-light-hover);
  }
`